import type { ISerialize } from '@/objects/ISerialize';

export class DeviceTransactionStatistics implements ISerialize {
    public Others: { [key: string]: number };

    public Status: { [key: string]: number };

    public Time: { [key: string]: number };

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Others?: { [key: string]: number };
        Status?: { [key: string]: number };
        Time?: { [key: string]: number };
    }) {
        this.Others = values.Others ?? {};

        this.Status = values.Status ?? {};

        this.Time = values.Time ?? {};
    }

    public serialize(): string {
        return (
            '{' +
            `"Others": ${JSON.stringify(this.Others)}` +
            ',' +
            `"Status": ${JSON.stringify(this.Status)}` +
            ',' +
            `"Time": ${JSON.stringify(this.Time)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DeviceTransactionStatistics from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Others?: { [key: string]: number };
        Status?: { [key: string]: number };
        Time?: { [key: string]: number };
    }): DeviceTransactionStatistics {
        return new DeviceTransactionStatistics(values);
    }

    public static _FromServerJson(json: any): DeviceTransactionStatistics {
        return new DeviceTransactionStatistics({ Others: json.Others, Status: json.Status, Time: json.Time });
    }

    /**
     * Creates an instance of DeviceTransactionStatistics from another instance of DeviceTransactionStatistics.
     * @param other The DeviceTransactionStatistics you want to clone
     * @returns A cloned DeviceTransactionStatistics
     */
    public static FromOther(other: DeviceTransactionStatistics): DeviceTransactionStatistics {
        return DeviceTransactionStatistics._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceTransactionStatistics.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceTransactionStatistics';
}
